import React from "react";
import logo from "../../assets/images/logo.png";

const css = `
@keyframes crays-breathe {
  0%, 100% { transform: scale(1);   opacity: 1; }
  50%       { transform: scale(1.08); opacity: 0.85; }
}
@keyframes crays-ring {
  0%   { transform: scale(0.85); opacity: 0.6; }
  50%  { transform: scale(1.15); opacity: 0; }
  100% { transform: scale(0.85); opacity: 0; }
}
`;

export const PageLoader: React.FC = () => (
  <>
    <style>{css}</style>
    <div className="fixed inset-0 bg-charcoal flex items-center justify-center z-50">
      <div className="flex flex-col items-center gap-6">
        {/* Logo + ripple ring */}
        <div className="relative flex items-center justify-center">
          {/* Ripple ring */}
          <div
            className="absolute rounded-full bg-gradient-to-tr from-yellow via-magenta to-magenta opacity-0"
            style={{
              width: 96,
              height: 96,
              animation: 'crays-ring 1.6s ease-out infinite',
            }}
          />
          {/* Logo */}
          <img
            src={logo}
            alt="Crays"
            className="relative h-16 w-auto"
            style={{ animation: 'crays-breathe 1.6s ease-in-out infinite' }}
          />
        </div>

        {/* Dot trail */}
        <div className="flex items-center gap-1.5">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-1.5 h-1.5 rounded-full bg-magenta"
              style={{
                animation: `crays-breathe 1.2s ease-in-out ${i * 0.2}s infinite`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  </>
);
